// extracted by mini-css-extract-plugin
module.exports = {"logo":"ErrorPage_logo__cQOkw","container":"ErrorPage_container__WJT8c","textContainer":"ErrorPage_textContainer__A4DV_"};